import { useStateManager } from "@bcm-dev/bcms-vite";
import UINotifiDayPicker from "components/shared/notifi/UINotifiDayPicker";
import UINotifiTimePicker from "components/shared/notifi/UINotifiTimePicker";
import { Weekday } from "model";

import "./styles.css";
import "./mobile.css";


export default function ScheduleAlertWidget(props) {
    const alertDetail = props.alertDetail ?? {};
    const scheduledAlert = props.scheduledAlert ?? {};
    const scheduledTime = scheduledAlert.scheduledTime ?? {};
    const { updateTimeOfDay, updateScheduledTimeWeekdays } = useStateManager();
    
    const selectedWeekdays = Weekday.initAll().filter(item => scheduledAlert.weekdayIDs.includes(item.id));
    const dayMessage = selectedWeekdays.reduce((acc, item, i) => {
        acc += `${ item.description }, `;
        if(i + 1 === selectedWeekdays.length) acc = acc.slice(0, -2);
        return acc;
    }, "");
    
    const hour = scheduledTime.hour === "" || isNaN(scheduledTime.hour) ? "" : scheduledTime.hour;
    const timeOfDay = scheduledTime.timeOfDay;
    const minute = scheduledTime.minute === "" || isNaN(scheduledTime.minute) ? "" : scheduledTime.minute;
    const hoursMessage = hour ? `${ hour }:${ minute } ${ timeOfDay }` : "";
    let message = selectedWeekdays.length > 0 ? `Every ${ dayMessage } at ${ hoursMessage }` : "";
    message = selectedWeekdays.length === 7 ? `Everday at ${ hoursMessage }` : message;

    return (
        <div className="schedule-alert-widget">
            <UINotifiDayPicker alertDetail={ alertDetail } scheduledAlert={ scheduledAlert } updateScheduledTimeWeekdays={ updateScheduledTimeWeekdays } />
            <UINotifiTimePicker alertDetail={ alertDetail } scheduledTime={ scheduledAlert.scheduledTime } updateTimeOfDay={ updateTimeOfDay } />
            <div className="flex-container flex-horizontal scheduled-time-container">
                <p className="sub-text scheduled-time-text">{ message }</p>
            </div>
        </div>
    )
}



